export enum ErrorSerial {
    /**
     * general or unknown errors
     */
    GENERAL = "1000",

    /**
     * errors when registering for getting notifications
     */
    REGISTRATION = "1001",

    /**
     * errors while fetching notifications
     */
    NOTIFICATIONS = "1002",
}
